import React from 'react'

const NotFoundScreen = ({ location }) => {
  return <h1>Página não encontrada para <code>{location.pathname}</code></h1>
};

export default NotFoundScreen;
